import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { PatientProvider } from '../../models/patient-provider';

@Injectable({
  providedIn: 'root',
})
export class PatientProviderService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientProvidersEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientProviders`;

  getPatientCareTeam(patientId: number): Observable<PatientProvider[]> {
    const url = `${this.patientProvidersEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientProvider[]>(url);
  }
}
